// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1Zhg0","addWidgetButton":"Header_addWidgetButton__1zghe","dashboardTabs":"Header_dashboardTabs__2--a0","active":"Header_active__1Jm8h"};